import { WhatsNew } from "@/common/model/WhatsNew";
import WhatsNewItem from "./WhatsNewItem";

type WhatsNewListProps = {
  whatsNewItems: WhatsNew[];
  onEdit: (whatsNew: WhatsNew) => void;
  onDelete: (whatsNew: WhatsNew) => void;
};

const WhatsNewList: React.FC<WhatsNewListProps> = ({
  whatsNewItems,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="space-y-4">
      Total {whatsNewItems.length} notifications
      {whatsNewItems.map((item) => (
        <WhatsNewItem
          key={item.id}
          whatsNew={item}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
      {whatsNewItems.length === 0 && (
        <div className="text-center py-8">
          No notifications found. Add a new notification to get started.
        </div>
      )}
    </div>
  );
};

export default WhatsNewList;
